import React from 'react';
import { AddCaseDetails } from 'pages/components';

const ContactNewAddCaseDetails = (props) => (
  <AddCaseDetails {...props} />
);

export default ContactNewAddCaseDetails;
